import { LitElement } from 'lit';
import { html, css } from 'lit';
import { Image } from '../../Image/Image';
import { Button } from '../../Buttons/Buttons';
import '../../Time/Timestamp';
import '../../ReadMark/SingleMark/SingleMark.js';
import '../../ReadMark/BlueReadMark/BlueReadMark.js';
import '../../ReadMark/DoubleMark/DoubleMark.js';
import '../../ReadMark/ClockMark/ClockMark.js';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
import {pdfSvg} from '../../../../assets/svg/PdfDocument.js';
import {excelSvg} from '../../../../assets/svg/ExcelDocument.js';
import { parseMessageWithLink } from '../../../../lib/helpers.js';
import { processTextWithMentions } from '../../../../lib/taguser.js';
import '../../EmojiReactions/EmojiReactions.js';
import '../../Popup/ConfirmationPopup/DeleteConfirmationPopup/DeletePopup.js';
import '../../../../components/ChatUIComponent/ReactionContainer.js';
import'../../ForwardMessage/ForwardUi.js'

class DocumentMessageBubble extends LitElement {
  static properties = {
    bgColor: { type: String },
    borderWidth: { type: String },
    borderColor: { type: String },
    borderStyle: { type: String },
    borderRadius: { type: String },
    padding: { type: String },
    docName: { type: String },
    width: { type: String },
    height: { type: String },
    documentNameBg: { type: String },
    documentNamePadding: { type: String },
    time: { type: String },
    href: { type: String },
    fileName: { type: String },
    isRead: { type: Boolean },
    isSelf: { type: Boolean },
    isPopupOpen: { type: Boolean },
    isDelivered: { type: String },
    docType: { type: String },
    textColor: { type: String },
    message: { type: String },
    mentionedUsers: { type: Array },
    messageId: { type: String },
    reactions: { type: Object },
    showConfirmationPopup: { type: Boolean },
    selectedEmojiToRemove: { type: Object },
    showAllReactionsPopup: {type: Boolean},
    showReactionButton: {type: Boolean},
    showEmojiReactions: {type: Boolean},
    userMetaData: {type: Boolean},
    messageType:{ type: Number },
    timeColor: { type: String },
    showReactionOnHover: {type: Boolean}
  };

  constructor() {
    super();
    this.isPopupOpen = false;
    this.showReactionButton = false;
    this.showEmojiReactions = false;
    this.reactions = {};
    this.showAllReactionsPopup = false;
    this.showReactionOnHover = true;
  }
  static styles = css`
    .document-message-container {
      display: flex;
      align-items: start;
      font-size: 16px;
      justify-content: space-between;
      flex-direction: column;
      position: relative;
    }
    .doc-container {
      display: flex;
      align-items: center;
      width: 90%;
      padding: 4px 8px 4px 8px;
      border-radius:4px;
      color:var(--text-primary-color);
    }
    .document-name {
      display: flex;
      align-items: center;
      gap: 2px;
      width: 100%;
      font-size: 14px;
      word-break: break-word;
    }
    .truncate {
      display: inline-block;
      max-width: 90%;
      word-wrap: break-word;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .time-stamp-container {
      position: absolute;
      bottom: 5px;
      right: 10px;
      display: flex;
      align-items: center;
      gap: 2px;
      margin-bottom: 10px;
    }

    .actions {
      position: absolute;
      left: -15px;
      cursor: pointer;
      top: 5px;
    }

    .popup {
      position: absolute;
      top: 0px;
      left: -100px;
      background-color: white;
      border: 1px solid #eef1fa;
      border-radius: 5px;
      padding: 10px;
      box-shadow: 0 2px 10px #eef1fa;
      z-index: 10;
      display: flex;
      flex-items: column;
      align-items: center;
      justify-content: center;
    }
        reaction-container {
      display: block;
       min-height: 150px;
       max-height: fit-content;
       min-width: 300px;
       max-width: 400px;
       position: absolute;
       z-index: 100;
    }

    .popup div {
      cursor: pointer;
    }
  .emoji-slider {
      position: absolute;
    }

    emoji-reactions {
      position: absolute;
      top: 15px;
      z-index: 99;
      left: 0;
    }

    .reaction-button {
      position: absolute;
      top: 50%;
      right: -25px;
      transform: translateY(-50%);
      cursor: pointer;
      z-index: 100;
    }

      .remaining-count {
      background-color: var(--bg-primary-light);
      font-size: 14px;
      display: flex;
      justify-content: center;
      color: var(--text-primary-color);
      width: 25px;
      cursor: pointer;
    }

    .reactions-display {
      position: absolute;
      bottom: -10px;
      right: 10px;
      display: grid;
      grid-template-columns: repeat(3, auto);
      gap: 0;
      margin-top: 4px;
      background-color: transparent;
    }

    .reaction-item {
      display: flex;
      align-items: center;
      gap: 2px;
      border-radius: 12px;
      font-size: 20px;
      background: var(--bg-secondary-color);
      cursor: pointer;
    }
  `;

  openPopup() {
    this.isPopupOpen = !this.isPopupOpen;
  }
  truncateDocName(docName) {
    const lastDotIndex = docName.lastIndexOf('.');
    const name = lastDotIndex !== -1 ? docName.slice(0, lastDotIndex) : docName;
    const extension = lastDotIndex !== -1 ? docName.slice(lastDotIndex) : '';

    const availableSpace = 40 - extension.length;

    if (name.length <= availableSpace) {
      const firstLine = name.slice(0, Math.min(20, name.length));
      const secondLine = name.slice(20);
      return `${firstLine}<br/>${secondLine}${extension}`;
    } else {
      const truncatedName = name.slice(0, availableSpace - 3) + '...';
      const firstLine = truncatedName.slice(0, 20);
      const secondLine = truncatedName.slice(20);
      return `${firstLine} ${secondLine}${extension}`;
    }
  }

  handleMentionClick = (user) => {
    this.dispatchEvent(
      new CustomEvent('tagUserClick', {
        detail: { userId: user?.userId, userName: user?.userName },
        bubbles: true,
        composed: true,
      })
    );
  };

  handleMouseEnter() {
    if(this.showReactionOnHover) {
    this.showReactionButton = true;
    }
  }


  handleReactionRemove(reaction) {
    this.showEmojiReactions = false;

    this.showConfirmationPopup = true;
    this.selectedEmojiToRemove = reaction;
    setTimeout(() => {
      document.addEventListener('click', this.handleOutsideClick)
    }, 100)
  }

  handleMouseLeave(e) {
    const messageContainer = this.renderRoot.querySelector('.message-container');
    const emojiReactions = this.renderRoot.querySelector('emoji-reactions');
    const reactionButton = this.renderRoot.querySelector('.reaction-button');

    const isEmojiSliderOpen = this.showEmojiReactions;

    const isMovingToMessage = messageContainer?.contains(e.relatedTarget);
    const isMovingToEmoji = emojiReactions && emojiReactions?.contains(e.relatedTarget);
    const isMovingToReactionButton = reactionButton && reactionButton?.contains(e.relatedTarget);

    if (!isMovingToMessage && !isMovingToEmoji && !isMovingToReactionButton) {
      this.showReactionButton = false;
      
      if (!isEmojiSliderOpen) {
        this.showEmojiReactions = false;
      }
    }
  }

  handleOutsideClick = (e) => {
    const emojiReactions = this.renderRoot.querySelector('emoji-reactions');
    const messageContainer = this.renderRoot.querySelector('.message-container');
    const reactionContainer = this.renderRoot.querySelector('reaction-container');
    
    const path = e.composedPath();
    
    if ((this.showEmojiReactions &&
      !path.includes(emojiReactions) &&
      !path.includes(messageContainer)) ||
      (this.showConfirmationPopup &&
      !path.includes(reactionContainer) &&
      !path.includes(messageContainer))
    ) {
      this.showEmojiReactions = false;
      this.showConfirmationPopup = false;
      document.removeEventListener('click', this.handleOutsideClick);
    }
  }
  toggleEmojiReactions() {
    this.showConfirmationPopup = false;

    this.showEmojiReactions = !this.showEmojiReactions;
    
    if (this.showEmojiReactions) {
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick);
      }, 100);
    }
  }
  handleEmojiClick(emoji) {
    const currentUserId = this.userMetaData?.userId;
    const usersForEmoji = this.reactions[emoji.id] || [];
    const hasReaction = usersForEmoji.includes(currentUserId);
  
    let existingReactionEmojiId = null;
  
    for (const [emojiId, userIds] of Object.entries(this.reactions)) {
      if (userIds.includes(currentUserId)) {
        existingReactionEmojiId = emojiId;
        break;
      }
    }
  
    if (existingReactionEmojiId && existingReactionEmojiId !== emoji.id) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: existingReactionEmojiId,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  
    if (hasReaction) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: emoji.id,
          },
          bubbles: true,
          composed: true,
        }),
      );
    } else {
      this.dispatchEvent(
        new CustomEvent('reaction-added', {
          detail: {
            messageId: this.messageId,
            emojiId: emoji.id,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  
    this.showEmojiReactions = false;
    document.removeEventListener('click', this.handleOutsideClick);
  }
  handleConfirmRemove() {
    if (this.selectedEmojiToRemove) {
      this.dispatchEvent(
        new CustomEvent('reaction-removed', {
          detail: {
            messageId: this.messageId,
            emojiId: this.selectedEmojiToRemove.emojiId,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
    this.closeConfirmationPopup();
  }

  closeConfirmationPopup() {
    this.showConfirmationPopup = false;
    this.selectedEmojiToRemove = null;
  }


  render() {
    const emojiList = document.createElement('emoji-reactions').emojis;
    const allReactions = Object.keys(this.reactions)
      .map(reaction => {
        const matchingEmoji = emojiList.find(emoji => emoji.id === reaction);
        return {
          emojiId: reaction,
          messageId: this.reactions[reaction],
          src: matchingEmoji?.src,
        };
      })
      .filter(reaction => Array.isArray(reaction.messageId) && reaction.messageId.length > 0); 
    
    const visibleReactions = allReactions.slice(0, 2);
    const remainingCount = allReactions.length > 2 ? allReactions.length - 2 : 0;;
    return html`
      <div
       @mouseover="${() => this.handleMouseEnter()}"
        @mouseout="${e => this.handleMouseLeave(e)}"
        class="document-message-container"
        style="padding:${this.padding};
          border-width: ${this.borderWidth};
          border-color: ${this.borderColor};
          border-style:${this.borderStyle};
          border-radius:${this.borderRadius || '6px'};
          background-color: ${this.bgColor || '#000'};
          height: ${this.height};
          width: ${this.width};
         "
      >
       ${this.messageType === 1
                ? html`
                   <forward-ui></forward-ui>
                  `
                : null}
       ${!this.isSelf && this.showReactionButton
          ? html`
        <div class="reaction-button" @click="${() => this.toggleEmojiReactions()}"  ">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--text-primary-color)">
            <path d="M612-516q25 0 42.5-17.5T672-576q0-25-17.5-42.5T612-636q-25 0-42.5 17.5T552-576q0 25 17.5 42.5T612-516Zm-264 0q25 0 42.5-17.5T408-576q0-25-17.5-42.5T348-636q-25 0-42.5 17.5T288-576q0 25 17.5 42.5T348-516Zm132 228q60 0 110.5-31t79.5-84H290q29 53 79.5 84T480-288Zm.28 192Q401-96 331-126t-122.5-82.5Q156-261 126-330.96t-30-149.5Q96-560 126-629.5q30-69.5 82.5-122T330.96-834q69.96-30 149.5-30t149.04 30q69.5 30 122 82.5T834-629.28q30 69.73 30 149Q864-401 834-331t-82.5 122.5Q699-156 629.28-126q-69.73 30-149 30ZM480-480Zm0 312q130 0 221-91t91-221q0-130-91-221t-221-91q-130 0-221 91t-91 221q0 130 91 221t221 91Z"/>
          </svg>
        </div>
      `
          : ''}

            ${this.showConfirmationPopup
          ? html` <reaction-container .messageId=${this.messageId} .userMetaData=${this.userMetaData} .reactions=${allReactions}></reaction-container> `
          : ''}
        ${this.showEmojiReactions
          ? html`
              <emoji-reactions .isOpen="${this.showEmojiReactions}" .onEmojiSelect="${emoji => this.handleEmojiClick(emoji)}" .selectedEmojis="${this.reactions}"></emoji-reactions>
            `
          : ''}

        <div class="reactions-display">
          ${visibleReactions?.map(
            reaction => html`
              <span class="reaction-item" @click="${() => this.handleReactionRemove(reaction)}"> ${reaction.src ? html`<span>${reaction.src}</span>` : ''} </span>
            `,
          )}
         ${remainingCount > 0
            ? html`
                <span @click="${() => this.handleReactionRemove(visibleReactions[0])}" class="reaction-item remaining-count" "> +${remainingCount} </span>
              
              `
            : ''}
        </div>
        <div class="doc-container" style="background-color: ${this.documentNameBg || 'var(--bg-primary-light)'};">
          <div class="document-name" style=" padding: ${this.documentNamePadding || '5px 10px 5px 0'}">
            ${this.docType.includes('vnd.openxmlformats-officedocument.spreadsheetml.sheet')
              ? html`<div class='attachment-icon'>${unsafeSVG(excelSvg)}</div>`
              : this.docType.includes('application/pdf')
                ? html`<div class='attachment-icon'>${unsafeSVG(pdfSvg)}</div>`
                : Image({
                    src: 'https://flexcrew.s3.us-west-1.amazonaws.com/document_text_svgrepo_com_1_2583e4b5fc.svg',
                    alt: 'documentIcon',
                    height: '25px',
                    width: '25px',
                  })}
            <span .innerHTML=${this.truncateDocName(this.docName || 'Document')}></span>
          </div>
          <a href=${this.href} download=${this.fileName} target="_blank">
            <svg width="24" fill="var(--text-primary-color)" height="24" viewBox="0 0 24 24">
                <path
                  d="M9.163 2.819C9 3.139 9 3.559 9 4.4V11H7.803c-.883 0-1.325 0-1.534.176a.75.75 0 0 0-.266.62c.017.274.322.593.931 1.232l4.198 4.401c.302.318.453.476.63.535a.749.749 0 0 0 .476 0c.177-.059.328-.217.63-.535l4.198-4.4c.61-.64.914-.96.93-1.233a.75.75 0 0 0-.265-.62C17.522 11 17.081 11 16.197 11H15V4.4c0-.84 0-1.26-.164-1.581a1.5 1.5 0 0 0-.655-.656C13.861 2 13.441 2 12.6 2h-1.2c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656zM5 21a1 1 0 0 0 1 1h12a1 1 0 1 0 0-2H6a1 1 0 0 0-1 1z"
                />
              </svg>
          </a>
        </div>
 ${this.message && !this.message.includes('AttachmentMessage:')
        ? html`
              <span style="font-size: 14px; color: ${this.textColor}">
              ${processTextWithMentions(this.message, this.mentionedUsers, this.handleMentionClick, this.isSelf)}
              </span>
            `
        : null}
        <div class="time-stamp-container">
          <timestamp-element .time="${this.time}" .color="${this.timeColor}"></timestamp-element>
          ${this.isSelf
            ? this.isRead == true
              ? html`<blue-read-mark></blue-read-mark>`
              : this.isDelivered == 'true'
                ? html`<double-mark></double-mark>`
                : this.isDelivered == 'pending'
                  ? html`<clock-mark></clock-mark>`
                  : html`<single-mark></single-mark>`
            : null}
        </div>
      </div>
    `;
  }
}

customElements.define('document-message', DocumentMessageBubble);
